var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuhamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 12.5,
    viewBox: "0 0 25 12.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M24.219,97.805H.781a.781.781,0,0,1,0-1.562H24.219a.781.781,0,0,1,0,1.562Z",
    transform: "translate(0 -96.243)",
    fill: "#003358"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M.781,180.455H24.219a.781.781,0,1,1,0,1.562H.781a.781.781,0,1,1,0-1.562Z",
    transform: "translate(0 -174.986)",
    fill: "#003358"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M121.084,264.667h15.625a.781.781,0,0,1,0,1.562H121.084a.781.781,0,1,1,0-1.562Z",
    transform: "translate(-120.303 -253.729)",
    fill: "#003358"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuhamburger);
export default __webpack_public_path__ + "static/media/icon_menuhamburger.c4f89e35cd631391a051cfb260d34221.svg";
export { ForwardRef as ReactComponent };